import React, { useState } from "react";

import leafImg from "@/assets/images/resources/leaf.png";
import faqImage from "@/assets/images/resources/faq.png";

export default function FaqOne() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "Quelles sont les méthodes de culture les plus durables ?",
      answer:
        "Les méthodes de culture durables privilégient la rotation des cultures, la réduction des intrants chimiques et l’optimisation de l’irrigation pour préserver les ressources naturelles et la fertilité des sols.",
    },
    {
      question: "Comment les changements climatiques affectent-ils les récoltes ?",
      answer:
        "Les changements climatiques modifient les cycles de pluie et de température, ce qui peut impacter le rendement, accroître les risques de maladies et nécessiter une adaptation continue des pratiques agricoles.",
    },
    {
      question:
        "Quels sont les avantages de l'agriculture biologique par rapport à l'agriculture conventionnelle ?",
      answer:
        "L’agriculture biologique favorise la biodiversité, limite l’utilisation de produits chimiques de synthèse et contribue à une meilleure qualité des sols, tout en répondant à une demande croissante de produits plus sains.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <>
      <section className="faq_one" style={{ marginTop: '120px' }}>
        <div className="container">
          <div className="row">
            {/* Left */}
            <div className="col-xl-6 col-lg-6">
              <div className="faq_one_left">
                <div className="block-title text-left">
                  <p>QUESTIONS FRÉQUEMMENT POSÉES</p>
                  <h3>AVEZ-VOUS DES QUESTIONS ?</h3>

                  <div className="leaf">
                    <img src={leafImg} alt="Leaf" />
                  </div>
                </div>

                <div
                  className="faq_one_image"
                  style={{ backgroundImage: `url(${faqImage})` }}
                >
                  <div className="phone_number">
                    <p> 
                      <span>Appelez-nous maintenant</span>
                      <a href="tel:27 920 900">27 920 900</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right */}
            <div className="col-xl-6 col-lg-6">
              <div className="faq_one_right">
                <div className="accordion-container-one">
                  {faqs.map((item, index) => (
                    <div
                      key={index}
                      className={`ac ${activeIndex === index ? "is-active" : ""}`}
                    >
                      <h2
                        className="ac-q"
                        onClick={() => toggleAccordion(index)}
                      >
                        {item.question}
                      </h2>

                      <div
                        className="ac-a"
                        style={{
                          maxHeight: activeIndex === index ? "200px" : "0",
                          visibility:
                            activeIndex === index ? "visible" : "hidden",
                        }}
                      >
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CSS in same file */}
      <style>{`
        .ac {
          margin-top: 10px;
          padding: 10px;
          background: #ffffff;
          box-sizing: border-box;
          border-radius: 6px;
          transition: all 0.3s ease;
          box-shadow: 0 0 10px rgba(0,0,0,0.05);
        }

        .ac-q {
          font-size: 20px;
          color: #444;
          padding: 10px 30px 10px 10px;
          margin: 0;
          cursor: pointer;
          position: relative;
          font-weight: 400;
          font-family: var(--heading-font);
        }

        .ac-q::after {
          content: '+';
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }

        .ac.is-active .ac-q {
          color: #5a8b50;
        }

        .ac.is-active .ac-q::after {
          content: '−';
          color: #5a8b50;
        }

        .ac-a {
          overflow: hidden;
          transition: max-height 0.3s ease, visibility 0.3s ease;
        }

        .ac-a p {
          color: #878e9c;
          margin: 0;
          padding: 10px 0;
          font-size: 16px;
          font-weight: 400;
        }
      `}</style>
    </>
  );
}